import type {MaterialSymbol} from 'material-symbols';
import type {VariantProps} from 'tailwind-variants';
import {tv} from 'tailwind-variants';
import type {Class} from 'Catalyst/class';
import {default as Icon} from './Icon.svelte';

export const iconTvProps = tv({
  slots: {
    base: `
      inline-flex
      items-center
      justify-center
    `,
    icon: '',
  },
  variants: {
    density: {
      compact: {},
      default: {},
    },
    size: {
      '16dp': {},
      '20dp': {},
      '24dp': {},
      '40dp': {},
      '48dp': {},
    },
  },
  compoundVariants: [
    {
      density: 'compact',
      size: '16dp',
      class: {
        base: `
          size-3
        `,
        icon: `
          !text-base/none
        `,
      },
    },
    {
      density: 'compact',
      size: '20dp',
      class: {
        base: `
          size-4
        `,
        icon: `
          !text-xl/none
        `,
      },
    },
    {
      density: 'compact',
      size: '24dp',
      class: {
        base: `
          size-5
        `,
        icon: `
          !text-2xl/none
        `,
      },
    },
    {
      density: 'compact',
      size: '40dp',
      class: {
        base: `
          size-8
        `,
        icon: `
          !text-[2.5rem]/none
        `,
      },
    },
    {
      density: 'compact',
      size: '48dp',
      class: {
        base: `
          size-10
        `,
        icon: `
          !text-5xl/none
        `,
      },
    },
    {
      density: 'default',
      size: '16dp',
      class: {
        base: `
          size-4
        `,
        icon: `
          !text-base/none
        `,
      },
    },
    {
      density: 'default',
      size: '20dp',
      class: {
        base: `
          size-5
        `,
        icon: `
          !text-xl/none
        `,
      },
    },
    {
      density: 'default',
      size: '24dp',
      class: {
        base: `
          size-6
        `,
        icon: `
          !text-2xl/none
        `,
      },
    },
    {
      density: 'default',
      size: '40dp',
      class: {
        base: `
          size-10
        `,
        icon: `
          !text-[2.5rem]/none
        `,
      },
    },
    {
      density: 'default',
      size: '48dp',
      class: {
        base: `
          size-12
        `,
        icon: `
          !text-5xl/none
        `,
      },
    },
  ],
  defaultVariants: {
    density: 'default',
    size: '20dp',
  },
});

export type IconTVProps = VariantProps<typeof iconTvProps>;

export const fontelloIcons = ['dot', 'small_circle'] as const;

export type IconOwnProps = {
  filled: boolean;
  name: MaterialSymbol | (typeof fontelloIcons)[number] | '';
  style: 'outlined' | 'rounded' | 'sharp';
  color: string;
};
export type IconProps = IconTVProps & IconOwnProps & Class;

export {Icon};
